/**
* LanguagePackRegistry.js
* 
* Created on 14-mei-2014, 12:17:41
*
* @author Ivo Swartjes for Ranj
**/

import ArrayIterator from "/lib/html5-software-library/src/ranj/util/datastructures/array/ArrayIterator";

export default class LanguagePackRegistry {
    constructor() {
        this._languagePacks = [];
        this._assetURLsByLanguagePack = new Map();
    };

    registerLanguagePack(languagePack, lpAssetURL) {
        this._languagePacks.push(languagePack);
        this._assetURLsByLanguagePack.set(languagePack, lpAssetURL);
    };

    getAssetURLForLanguagePack(languagePack) {
        return this._assetURLsByLanguagePack.get(languagePack);
    };

    getAssetURLForLanguagePackID(languagePackID) {
        for (var i = 0; i < this._languagePacks.length; i++) {
            var curLP = this._languagePacks[i];
            if (curLP.hasText(languagePackID)) {
                return this.getAssetURLForLanguagePack(curLP);
            }
        }

        return null;
    };

    languagePackIterator() {
        return new ArrayIterator(this._languagePacks);
    };
}